const NotFound = (name) => (
  () => (
    <div style={{ display: 'block' }}>
      {process.env.production ? '' : `Flint: View "${name}" not found`}
    </div>
  )
)

export default NotFound



/** WEBPACK FOOTER **
 ** ./client/views/NotFound.js
 **/